export default __webpack_public_path__ + "static/media/toolbox.66b4f028.png";